import { render, staticRenderFns } from "./HumanReadableTime.vue?vue&type=template&id=efb9d0ba&scoped=true&"
import script from "./HumanReadableTime.vue?vue&type=script&lang=js&"
export * from "./HumanReadableTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb9d0ba",
  null
  
)

export default component.exports